import React, { useState, useEffect, useCallback } from 'react';
import TabellaCollassabile from './TabellaCollassabile';
import { getDatiFattura } from '../handlers/datiFatturaHandler';
import { SpinnerComp } from '../helper/spinner';
import Talk from '../helper/Talk';
import { Container, Form, Modal, Row, Col, Button, Alert } from 'react-bootstrap'
import { buildUrl } from "../helper/handler"
import { getFromApi, postToApi } from '../utilities/NetUtilities';

const getUrl730 = (url, organizzazioneNome, tipo, tutti) => {
    var params = {
        organizzazione: organizzazioneNome,
        tipo: tipo,
        tutti: tutti
    };
    return buildUrl(url, params);
};

function Tabella730(props) {
    const [dati, setDati] = useState([]);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [nomeOrganizzazione, setNomeOrganizzazione] = useState("");
    const [tipoOrganizzazione, setTipoOrganizzazione] = useState("");
    const [checked, setChecked] = useState(false);
    const [larghezza, setLarghezza] = useState("100%");

    // Stati per persistere lo stato delle singole tabelle (anni)
    const [tabelleAperte, setTabelleAperte] = useState({});
    const [tabelleCristallizzate, setTabelleCristallizzate] = useState({});

    // Stati per la modale di inserimento/modifica dati cristallizzati
    const [showModal, setShowModal] = useState(false);
    const [currentWeekData, setCurrentWeekData] = useState(null);
    const [modalError, setModalError] = useState("");
    const [formData, setFormData] = useState({
        numeroCumulativo730: "",
        numeroSettimanale730: "",
        appuntamentiFissatiInSettimana: "",
        ipotesiProduzioneTotale: "",
        ipotesiProduzioneSenzaStudi: "",
        numero730InModifica: "",
        numero730Stampa: ""
    });

    // Stati per modale di conferma eliminazione
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);

    const handleAllYears = (e) => {
        setLoading(true);
        setChecked(!checked);
        const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"))
        connessioneTabella730(organizzazioneMap.nome, organizzazioneMap.tipo, !checked)
    };

    const triggerCrystallize = (organizzazioneNome, tipo, anno, settimana) => {
        setLoading(true);
        const url = buildUrl('cristallizzariepilogototale', {
            organizzazione: organizzazioneNome,
            tipo: tipo,
            anno: anno,
            settimana: settimana
        });
        const okAction = (response) => {
            connessioneTabella730(organizzazioneNome, tipo, checked);
        };
        const nokAction = (response) => {
            setLoading(false);
            if (response && response.messaggi) {
                setError(response.messaggi.map(m => m.descrizione));
            } else {
                setError(["Errore durante la cristallizzazione"]);
            }
        };
        postToApi(url, {}, okAction, nokAction);
    };

    const triggerSaveCrystallize = (anno, datiCrist) => {
        setModalError("");
        setCurrentWeekData({ anno, settimana: datiCrist.numero });
        if (datiCrist.cristallizzato) {
            const cum = datiCrist.numerocumulativo730 || 0;
            const sett = datiCrist.numerosettimanale730 || 0;
            const app = datiCrist.appuntamentiFissatiInSettimana || 0;
            const ipo = datiCrist.ipotesiProduzioneTotale || 0;
            const ipoSenza = datiCrist.ipotesiProduzioneTotaleSenzaStudi || datiCrist.ipotesiProduzioneSenzaStudi || 0;
            const inMod = datiCrist.inmodifica || datiCrist.numero730InModifica || 0;
            const tot = datiCrist.totali || 0;

            setFormData({
                numeroCumulativo730: String(cum),
                numeroSettimanale730: String(sett),
                appuntamentiFissatiInSettimana: String(app),
                ipotesiProduzioneTotale: String(ipo),
                ipotesiProduzioneSenzaStudi: String(ipoSenza),
                numero730InModifica: String(inMod),
                numero730Stampa: String(Math.max(0, tot - inMod))
            });
        } else {
            setFormData({
                numeroCumulativo730: "",
                numeroSettimanale730: "",
                appuntamentiFissatiInSettimana: "",
                ipotesiProduzioneTotale: "",
                ipotesiProduzioneSenzaStudi: "",
                numero730InModifica: "",
                numero730Stampa: ""
            });
        }
        setShowModal(true);
    };

    const triggerDeleteCrystallize = (anno, settimana) => {
        setDeleteTarget({ anno, settimana });
        setShowConfirmModal(true);
    };

    const handleConfirmDelete = () => {
        if (!deleteTarget) return;
        const { anno, settimana } = deleteTarget;
        setShowConfirmModal(false);
        setLoading(true);
        const orgMap = JSON.parse(window.sessionStorage.getItem("organizzazione") || "{}");
        const orgNome = orgMap.nome || nomeOrganizzazione;
        const orgTipo = orgMap.tipo || tipoOrganizzazione;
        const url = buildUrl('deleteriepilogototalecristallizzato', {
            organizzazione: orgNome,
            tipo: orgTipo,
            anno: anno,
            settimana: settimana
        });
        const okAction = (response) => {
            connessioneTabella730(orgNome, orgTipo, checked);
        };
        const nokAction = (response) => {
            setLoading(false);
            if (response && response.messaggi) {
                setError(response.messaggi.map(m => m.descrizione));
            } else {
                setError(["Errore durante l'eliminazione della cristallizzazione"]);
            }
        };
        postToApi(url, {}, okAction, nokAction);
    };

    const handleModalSubmit = (e) => {
        e.preventDefault();
        
        const keys = [
            'numeroCumulativo730',
            'numeroSettimanale730',
            'appuntamentiFissatiInSettimana',
            'ipotesiProduzioneTotale',
            'ipotesiProduzioneSenzaStudi',
            'numero730InModifica'
        ];

        for (const key of keys) {
            if (!/^\d+$/.test(formData[key])) {
                setModalError("Tutti i campi devono essere numeri interi non negativi.");
                return;
            }
        }

        setModalError("");
        setShowModal(false);
        setLoading(true);
        const orgMap = JSON.parse(window.sessionStorage.getItem("organizzazione") || "{}");
        const orgNome = orgMap.nome || nomeOrganizzazione;
        const orgTipo = orgMap.tipo || tipoOrganizzazione;
        const url = buildUrl('salvariepilogototalecristallizzato', {
            organizzazione: orgNome,
            tipo: orgTipo,
            anno: currentWeekData.anno,
            settimana: currentWeekData.settimana,
            numeroCumulativo730: parseInt(formData.numeroCumulativo730, 10),
            numeroSettimanale730: parseInt(formData.numeroSettimanale730, 10),
            appuntamentiFissatiInSettimana: parseInt(formData.appuntamentiFissatiInSettimana, 10),
            ipotesiProduzioneTotale: parseInt(formData.ipotesiProduzioneTotale, 10),
            ipotesiProduzioneSenzaStudi: parseInt(formData.ipotesiProduzioneSenzaStudi, 10),
            numero730InModifica: parseInt(formData.numero730InModifica, 10)
        });
        const okAction = (response) => {
            connessioneTabella730(orgNome, orgTipo, checked);
        };
        const nokAction = (response) => {
            setLoading(false);
            if (response && response.messaggi) {
                setError(response.messaggi.map(m => m.descrizione));
            } else {
                setError(["Errore durante il salvataggio dei dati cristallizzati"]);
            }
        };
        postToApi(url, {}, okAction, nokAction);
    };

    const connessioneTabella730 = useCallback((organizzazioneNome, tipo, tutti) => {
        setLoading(true);
        const okAction = (data) => {
            setLoading(false);
            const { table, errore } = getDatiFattura(data.dati,
                props.format,
                props.type,
                props.nome,
                props.numero730inmodifica,
                organizzazioneNome,
                tipo,
                tutti,
                (anno, settimana) => triggerCrystallize(organizzazioneNome, tipo, anno, settimana),
                triggerSaveCrystallize,
                triggerDeleteCrystallize);
            setDati(table);
            setError(errore);
        }
        const nokAction = (data) => {
            setLoading(false);
            console.error("Errore caricamento tabella:", data);
            if (data && data.messaggi && data.messaggi[0]) {
                setError([data.messaggi[0].descrizione]);
            } else {
                setError(["Errore sconosciuto nel caricamento dei dati"]);
            }
        }
        const url = getUrl730(props.url, organizzazioneNome, tipo, tutti)
        getFromApi(url, okAction, nokAction);
    }, [props.format, props.nome, props.numero730inmodifica, props.type, props.url]);

    useEffect(() => {
        setLoading(true);
        const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        setNomeOrganizzazione(organizzazioneMap.nome);
        setTipoOrganizzazione(organizzazioneMap.tipo);
        if (organizzazioneMap) {
            connessioneTabella730(organizzazioneMap.nome, organizzazioneMap.tipo, false);
        }
    }, [connessioneTabella730]);

    const updateLarghezza = () => {
        if (!props.type.startsWith("riepilogo")) {
            setLarghezza("613%");
        }
    };

    return (
        <div className='main'>
            <Container fluid>
                <div style={{ width: `${larghezza}` }}>
                    <div className="divPaginaTitoleFisso" style={{ width: "900px" }}>
                        <h1 className="text-center">{props.titolo} ({nomeOrganizzazione.toLowerCase()}/{tipoOrganizzazione.toLowerCase()})
                        </h1>
                    </div>
                </div>
                <Talk errori={error} />
                {loading ? (
                    <SpinnerComp />
                ) : (
                    <div className='mt-5'>
                        <div style={{ width: `${larghezza}` }}>
                            <div className='scrollAllyear'>
                                <Form.Check
                                    inline
                                    checked={checked}
                                    className='ml-2 allYearsCheckbox mb-3'
                                    type="checkbox"
                                    id="default-checkbox"
                                    label="mostrare tutti gli anni"
                                    onChange={e => handleAllYears(e)}
                                ></Form.Check>
                            </div>
                        </div>
                        {dati.map((dati, key) => (
                            <div className="row" key={key}>
                                <TabellaCollassabile
                                    numeri730={dati.numeri730}
                                    numeriIsee={dati.numeriIsee}
                                    rows={dati.rows}
                                    rowsCristallizzato={dati.rowsCristallizzato}
                                    intestazione={dati.intestazione}
                                    nomeTabella={dati.name}
                                    button={dati.button}
                                    buttonCristallizzato={dati.buttonCristallizzato}
                                    open={!!tabelleAperte[dati.name]}
                                    setOpen={(val) => setTabelleAperte({ ...tabelleAperte, [dati.name]: val })}
                                    visualizzaCristallizzati={!!tabelleCristallizzate[dati.name]}
                                    setVisualizzaCristallizzati={(val) => setTabelleCristallizzate({ ...tabelleCristallizzate, [dati.name]: val })}
                                    setLarghezza={updateLarghezza}
                                    type={props.type} />
                            </div>
                        ))}
                    </div>
                )}
            </Container>

            {/* Modale per Inserimento/Modifica Dati Cristallizzati */}
            <Modal show={showModal} onHide={() => { setShowModal(false); setModalError(""); }}>
                <Form onSubmit={handleModalSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {currentWeekData ? `${currentWeekData.anno} - Settimana ${currentWeekData.settimana}` : ''}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {modalError && <Alert id="messaggio_popup" variant="danger">{modalError}</Alert>}
                        <Form.Group className="mb-3">
                            <Form.Label>Numero 730 confermati</Form.Label>
                            <Form.Control
                                type="text"
                                id="input_numeroCumulativo730"
                                value={formData.numeroCumulativo730}
                                onChange={e => {
                                    const val = e.target.value;
                                    setFormData({ ...formData, numeroCumulativo730: val, numero730Stampa: val });
                                }}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Numero Settimanale 730</Form.Label>
                            <Form.Control
                                type="text"
                                id="input_numeroSettimanale730"
                                value={formData.numeroSettimanale730}
                                onChange={e => setFormData({ ...formData, numeroSettimanale730: e.target.value })}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Appuntamenti Fissati in Settimana</Form.Label>
                            <Form.Control
                                type="text"
                                id="input_appuntamentiFissatiInSettimana"
                                value={formData.appuntamentiFissatiInSettimana}
                                onChange={e => setFormData({ ...formData, appuntamentiFissatiInSettimana: e.target.value })}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Ipotesi Produzione Totale</Form.Label>
                            <Form.Control
                                type="text"
                                id="input_ipotesiProduzioneTotale"
                                value={formData.ipotesiProduzioneTotale}
                                onChange={e => setFormData({ ...formData, ipotesiProduzioneTotale: e.target.value })}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Ipotesi Produzione Senza Studi</Form.Label>
                            <Form.Control
                                type="text"
                                id="input_ipotesiProduzioneSenzaStudi"
                                value={formData.ipotesiProduzioneSenzaStudi}
                                onChange={e => setFormData({ ...formData, ipotesiProduzioneSenzaStudi: e.target.value })}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Numero 730 in Modifica</Form.Label>
                            <Form.Control
                                type="text"
                                id="input_numero730InModifica"
                                value={formData.numero730InModifica}
                                onChange={e => setFormData({ ...formData, numero730InModifica: e.target.value })}
                                required
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => { setShowModal(false); setModalError(""); }}>
                            Annulla
                        </Button>
                        <Button variant="primary" type="submit" id="btn_save_crystallized_data">
                            Salva
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* Modale di Conferma Eliminazione Cristallizzazione */}
            <Modal show={showConfirmModal} onHide={() => { setShowConfirmModal(false); setDeleteTarget(null); }}>
                <Modal.Header closeButton>
                    <Modal.Title id="title_popup_confirm">Conferma eliminazione</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Sei sicuro di voler eliminare la cristallizzazione per la settimana {deleteTarget ? deleteTarget.settimana : ''}?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" id="annulla_elimina" onClick={() => { setShowConfirmModal(false); setDeleteTarget(null); }}>
                        Annulla
                    </Button>
                    <Button variant="danger" id="elimina" onClick={handleConfirmDelete}>
                        Elimina
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>)
}

export default Tabella730